import React from 'react';
import View from '../elements/View';
import { Col, Label } from 'reactstrap';
import { SearchInput } from './index';
import ToggleSelect from '../elements/ToggleSelect';
export var ToggleSelectLabeled = function (props) {
    var name = props.name, field = props.field, value = props.value, options = props.options, multiple = props.multiple, maxSelected = props.maxSelected, language = props.language, onSearchChange = props.onSearchChange, onChange = props.onChange, onMaxSelected = props.onMaxSelected;
    var intialSelected = value ? Array.isArray(value) ? value : [value] : [];
    var _a = React.useState(intialSelected), selectedArray = _a[0], setSelectedArray = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { flex: true, row: true },
            React.createElement(Label, { for: name, sm: 6 }, name),
            React.createElement(Col, { sm: 6 },
                React.createElement(SearchInput, { underline: true, onChange: function (val) {
                        onSearchChange({ value: val, field: field });
                    } }))),
        React.createElement(Col, { sm: 12 },
            React.createElement(ToggleSelect, { multiple: multiple, maxSelectable: maxSelected, name: name, options: options, value: selectedArray, onChange: onChange, onMaxSelected: onMaxSelected }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/ToggleSelectLabeled.tsx
// module id = 1517
// module chunks = 0